import { RiskLevel } from "@/model/RiskLevel";
import CountyDurhamLogo from "@/assets/regions/cumbria-logo.png";
import TheWellLogo from "@/assets/regions/the-well-logo.png";
const CumbriaBanner = {
    rawCopy: "For alcohol advice and support in Cumbria, call Recovery Steps on 01900 512300 or find out more <u>here</u>.",
    logoLink: "https://humankindcharity.org.uk/service/recovery-steps-cumbria/"
};
const CumbriaIncreasingBanner = {
    rawCopy: "For alcohol advice and support in Cumbria, call The Well on 01539 725 906 or find out more <u>here</u>.",
    logoLink: "https://www.thewellcommunities.co.uk/"
};
export default {
    name: "Cumbria",
    logo: {
        file: CountyDurhamLogo,
        width: 650,
        height: 260
    },
    logoIncreasing: {
        file: TheWellLogo,
        width: 237,
        height: 260,
    },
    regions: [
        "Allerdale",
        "Barrow-in-Furness",
        "Carlisle",
        "Copeland",
        "Eden",
        "South Lakeland"
    ],
    zoomLevel: 10,
    showServiceInfoOnResultsSummaryPage: true,
    bannerInfo: {
        default: CumbriaBanner,
        [RiskLevel.Lower]: CumbriaBanner,
        [RiskLevel.Increasing]: CumbriaIncreasingBanner,
        [RiskLevel.Higher]: CumbriaBanner,
        [RiskLevel.High]: CumbriaBanner
    },
    clinics: [
        {
            name: "Recovery Steps Cumbria",
            isPrimaryProvider: true,
            tagline: "Various locations across the North and South available.",
            description: "Contact ${name} on ${phone} or email <a href='mailto:${email}'>${email}</a>",
            other_info: "<strong><a href='tel:01900512300'>Call</a> or <a href='mailto:referrals@recoverystepscumbria.org.uk'>email</a> to arrange an appointment<br><br>",
            phone: ["01900 512300"],
            times: [
                {
                    title: "Opening times (by appointment only):",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            email: "referrals@recoverystepscumbria.org.uk",
            website: "https://humankindcharity.org.uk/service/recovery-steps-cumbria/"
        },
        {
            name: "Recovery Steps Cumbria - Carlisle",
            address: "Stocklund House, Castle Street, Carlisle, Cumbria, CA3 8SY",
            tagline: "Various locations across the North and South available.",
            description: "Contact ${name} on ${phone} or email <a href='mailto:${email}'>${email}</a>",
            other_info: "<strong><a href='tel:01900512300'>Call</a> or <a href='mailto:referrals@recoverystepscumbria.org.uk'>email</a> to arrange an appointment<br><br>",
            phone: ["01900 512300"],
            location: { lat: 54.8955062, lng: -2.9410636 },
            times: [
                {
                    title: "Opening times (by appointment only):",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            email: "referrals@recoverystepscumbria.org.uk",
            website: "https://humankindcharity.org.uk/service/recovery-steps-cumbria/"
        },
        {
            name: "Recovery Steps Cumbria - Copeland",
            address: "21b Lowther Street, Whitehaven, Cumbria, CA28 7DG",
            description: "Contact ${name} on ${phone} or email <a href='mailto:${email}'>${email}</a>",
            other_info: "<strong><a href='tel:01900512300'>Call</a> or <a href='mailto:referrals@recoverystepscumbria.org.uk'>email</a> to arrange an appointment<br><br>",
            phone: ["01900 512300"],
            location: { lat: 54.5476191, lng: -3.5901406 },
            times: [
                {
                    title: "Opening times (by appointment only):",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            email: "referrals@recoverystepscumbria.org.uk",
            website: "https://humankindcharity.org.uk/service/recovery-steps-cumbria/"
        },
        {
            name: "Recovery Steps Cumbria - Barrow-in-Furness",
            address: "92-96 Duke Street, Barrow-in-Furness, Cumbria, LA14 1RD",
            location: { lat: 54.1132673, lng: -3.2319797 },
            description: "Contact ${name} on ${phone} or email <a href='mailto:${email}'>${email}</a>",
            other_info: "<strong><a href='tel:01900512300'>Call</a> or <a href='mailto:referrals@recoverystepscumbria.org.uk'>email</a> to arrange an appointment<br><br>",
            phone: ["01900 512300"],
            times: [
                {
                    title: "Opening times (by appointment only):",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            email: "referrals@recoverystepscumbria.org.uk",
            website: "https://humankindcharity.org.uk/service/recovery-steps-cumbria/"
        },
        {
            name: "Recovery Steps Cumbria - South Lakeland",
            address: "South Lakes Foyer, Yard 95, Stricklandgate, Kendal, LA9 4RA",
            location: { lat: 54.3300556, lng: -2.7492999 },
            description: "Contact ${name} on ${phone} or email <a href='mailto:${email}'>${email}</a>",
            other_info: "<strong><a href='tel:01900512300'>Call</a> or <a href='mailto:referrals@recoverystepscumbria.org.uk'>email</a> to arrange an appointment<br><br>",
            phone: ["01900 512300"],
            times: [
                {
                    title: "Opening times (by appointment only):",
                    info: "By appointment only",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            email: "referrals@recoverystepscumbria.org.uk",
            website: "https://humankindcharity.org.uk/service/recovery-steps-cumbria/"
        },
        {
            name: "Recovery Steps Cumbria - Eden",
            address: "Office 2, The Foyer, Old London Road, Penrith, CA11 8ET",
            location: { lat: 54.6625265, lng: -2.7514083 },
            description: "Contact ${name} on ${phone} or email <a href='mailto:${email}'>${email}</a>",
            other_info: "<strong><a href='tel:01900512300'>Call</a> or <a href='mailto:referrals@recoverystepscumbria.org.uk'>email</a> to arrange an appointment<br><br>",
            phone: ["01900 512300"],
            times: [
                {
                    title: "Opening times (by appointment only):",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            email: "referrals@recoverystepscumbria.org.uk",
            website: "https://humankindcharity.org.uk/service/recovery-steps-cumbria/"
        },
        {
            name: "Recovery Steps Cumbria - Allerdale",
            address: "6 Finkle Street, Workington, Cumbria, CA14 2AY",
            location: { lat: 54.6445469, lng: -3.5484225 },
            description: "Contact ${name} on ${phone} or email <a href='mailto:${email}'>${email}</a>",
            other_info: "<strong><a href='tel:01900512300'>Call</a> or <a href='mailto:referrals@recoverystepscumbria.org.uk'>email</a> to arrange an appointment<br><br>",
            phone: ["01900 512300"],
            times: [
                {
                    title: "Opening times (by appointment only):",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            email: "referrals@recoverystepscumbria.org.uk",
            website: "https://humankindcharity.org.uk/service/recovery-steps-cumbria/"
        },
        {
            name: "The Well Communities CIC",
            address: "The Well Communities CIC, Highgate Hotel, 128 Highgate, Kendal, Cumbria, LA94HE",
            location: { lat: 54.3241236, lng: -2.7496959 },
            phone: ["01539 725 906"],
            times: [
                {
                    title: "Opening times (appointment or drop-in):",
                    times: {
                        monday: [{ start: 830, end: 1630 }],
                        tuesday: [{ start: 830, end: 1630 }],
                        wednesday: [{ start: 830, end: 1630 }],
                        thursday: [{ start: 830, end: 1630 }],
                        friday: [{ start: 830, end: 1630 }]
                    }
                }
            ],
            website: "https://www.thewellcommunities.co.uk"
        },
        {
            name: "The Well Communities CIC",
            address: "The Well Communities CIC, 242 - 244 Dalton Road, Barrow in Furness, Cumbria, LA141PN",
            location: { lat: 54.1155466, lng: -3.2293122 },
            phone: ["01229 829 832"],
            times: [
                {
                    title: "Opening times (appointment or drop-in):",
                    times: {
                        monday: [{ start: 830, end: 1630 }],
                        tuesday: [{ start: 830, end: 1630 }],
                        wednesday: [{ start: 830, end: 1630 }],
                        thursday: [{ start: 830, end: 1630 }],
                        friday: [{ start: 830, end: 1630 }]
                    }
                }
            ],
            website: "https://www.thewellcommunities.co.uk"
        },
        {
            name: "CADAS - Barrow-in-Furness",
            address: "52 Paradise Street, Barrow-in-Furness, LA14 1JG",
            location: { lat: 54.1118365, lng: -3.226744 },
            description: "1:1 support for young people (10+), adults, and family/friends/carers. Face-to-face, phone or online appointments available.",
            email: "contact@cadas.co.uk",
            website: "https://cadas.co.uk",
            phone: [{
                    title: "Helpline: (11am-6pm, Mon to Fri)",
                    value: "0800 2 54 56 58"
                }],
            showAtRiskLevel: [RiskLevel.Increasing, RiskLevel.Higher, RiskLevel.High]
        },
        {
            name: "CADAS - Allerdale",
            address: "Workington Town Hall, Oxford Street, Workington, CA14 2RS",
            location: { lat: 54.6435198, lng: -3.5546984 },
            description: "1:1 support for young people (10+), adults, and family/friends/carers. Face-to-face, phone or online appointments available.",
            email: "contact@cadas.co.uk",
            website: "https://cadas.co.uk",
            phone: [{
                    title: "Helpline: (11am-6pm, Mon to Fri)",
                    value: "0800 2 54 56 58"
                }],
            showAtRiskLevel: [RiskLevel.Increasing, RiskLevel.Higher, RiskLevel.High]
        },
        {
            name: "CADAS - Carlisle",
            address: "53-5 Victoria Place, Carlisle, CA1 1EJ",
            location: { lat: 54.895947, lng: -2.9282464 },
            description: "1:1 support for young people (10+), adults, and family/friends/carers. Face-to-face, phone or online appointments available.",
            email: "contact@cadas.co.uk",
            website: "https://cadas.co.uk",
            phone: [{
                    title: "Helpline: (11am-6pm, Mon to Fri)",
                    value: "0800 2 54 56 58"
                }],
            showAtRiskLevel: [RiskLevel.Increasing, RiskLevel.Higher, RiskLevel.High]
        },
        {
            name: "CADAS - South Lakeland",
            address: "The Stephenson Centre, Ann Street, Kendal, LA9 6AA",
            location: { lat: 54.3312358, lng: -2.7415749 },
            description: "1:1 support for young people (10+), adults, and family/friends/carers. Face-to-face, phone or online appointments available.",
            email: "contact@cadas.co.uk",
            website: "https://cadas.co.uk",
            phone: [{
                    title: "Helpline: (11am-6pm, Mon to Fri)",
                    value: "0800 2 54 56 58"
                }],
            showAtRiskLevel: [RiskLevel.Increasing, RiskLevel.Higher, RiskLevel.High]
        },
    ],
};
//# sourceMappingURL=Cumbria.js.map